var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsProdDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Delete_1123191",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.195,
    height: 16.315,
    viewBox: "0 0 12.195 16.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36480",
    "data-name": "Path 36480",
    d: "M20.286,17.669h.008a.442.442,0,0,0,.433-.45l-.177-9.5a.442.442,0,0,0-.441-.433H20.1a.442.442,0,0,0-.433.45l.177,9.5A.442.442,0,0,0,20.286,17.669Zm2.583,0a.442.442,0,0,0,.441-.433l.177-9.5a.442.442,0,0,0-.433-.45h-.008a.442.442,0,0,0-.441.433l-.177,9.5a.442.442,0,0,0,.433.45ZM26.342,7.287a.443.443,0,0,0-.456.427L25.533,18.7a.543.543,0,0,1-.542.543H18.165a.547.547,0,0,1-.543-.557L17.269,7.714a.442.442,0,0,0-.883.028L16.739,18.7a1.428,1.428,0,0,0,1.426,1.426h6.827a1.424,1.424,0,0,0,1.425-1.412l.353-10.976A.442.442,0,0,0,26.342,7.287Zm.891-1.766H24.46l-.28-1.354a.442.442,0,0,0-.432-.352H19.409a.442.442,0,0,0-.432.352L18.7,5.521H15.922a.442.442,0,0,0,0,.883H27.233a.442.442,0,1,0,0-.883Zm-7.635,0,.17-.822h3.619l.17.822H19.6Z",
    transform: "translate(-15.48 -3.815)",
    fill: "#9399a4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsProdDelete);
export default __webpack_public_path__ + "static/media/ws-prod-delete.27d89f2b99545cdfe4289120e1facbea.svg";
export { ForwardRef as ReactComponent };